<!-- App Main Structure -->
<template>
	<div class="app-horizontal-layout">
		<template v-if="loading">
			<rotate-square2></rotate-square2>
		</template>
		<template v-else>
			<!-- App Header -->
			<app-header :horizontal="true"></app-header>
			<!-- App Main Content -->
			<v-content class="mt-0 mb-0 base-heig">
				<v-btn color="error" class="ma-0" block @click="$router.push({name: 'Facturas'})" v-if="estadoCartera">
					<v-icon left>warning</v-icon>
					{{estadoCartera}}
				</v-btn>
				<!-- App Router -->
				<transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
					<router-view></router-view>
				</transition>
			</v-content>
			<!-- app customizer -->
			<app-customizer></app-customizer>
		</template>
	</div>
</template>

<script>
import Header from 'Components/Header/Header.vue'
import Customizer from 'Components/Customizer/Customizer'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    appHeader: Header,
    appCustomizer: Customizer
  },
	beforeCreate () {
		this.$store.dispatch('getComplements')
		this.$store.dispatch('getFacturas')
		this.$store.dispatch('getSettingsMipres')
	},
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 1500)
  },
  computed: {
    ...mapGetters([
    		'estadoCartera',
    		'selectedRouterAnimation'
	])
  }
}
</script>

<style>
.app-horizontal-layout {
  height: 100vh;
}
.base-heig>.v-content__wrap {
	height: calc(100vh - 66px) !important;
}
</style>

